<div class="inicio"><br>

    <mat-tab-group (selectedIndexChange)="myTabSelectedIndexChange($event)">
    
        <mat-tab label="PENDIENTES">   
        
            <div class="inicio">
                
                <br>
                <p class="titulo">
                    SOLICITUDES DE EQUIPO
                    <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)" >
                        <mat-icon>info</mat-icon> 
                    </button>
                </p>
                <br>

                <div class="div">

                    <div class="grid-container2">
                        <div class="celda">
                            <mat-form-field  appearance="fill" floatLabel="always">
                                <mat-label>BUSCAR</mat-label>
                                <input matInput (keyup)="filtroDataP($event)"  placeholder="Ingrese el dato a buscar">
                            </mat-form-field>
                        </div>
                    </div>

                    <table mat-table [dataSource] = "dataSourceP" class="mat-elevation-z8">
        
                        <ng-container matColumnDef="OPCIONES">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab color="accent" matTooltip="Click aquí para ver a detalle la solicitud." (click)="clickVerDetalle(element.id_solicitud_asig_equipo,element.status_solicitud)"> <mat-icon >visibility</mat-icon> </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="EQUIPO SOLICITADO">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> EQUIPO SOLICITADO </th>
                            <td mat-cell *matCellDef="let element"> {{element.tipo_equipo}} </td>
                        </ng-container>

                        <ng-container matColumnDef="COLABORADOR">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="CARGO DEL COLABORADOR">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="OFICINA/SUCURSAL">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> OFICINA/SUCURSAL </th>
                            <td mat-cell *matCellDef="let element"> {{element.colaborador.sucursal.nombreSucursal}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="SOLICITANTE">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                        </ng-container>

                        <ng-container matColumnDef="FECHA DE SOLICITUD">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD</th>
                            <td mat-cell *matCellDef="let element"> {{element.fecha_solicitud}} </td>
                        </ng-container>
            
                        <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                        <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
                    
                    </table>

                    <mat-paginator #paginatorP class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

                </div>

            </div>

        </mat-tab>
        
        <mat-tab label="ATENDIDAS ">   
            <div class="inicio">

                <br>
                <p class="titulo">
                    SOLICITUDES DE EQUIPO
                    <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)" >
                        <mat-icon>info</mat-icon> 
                    </button>
                </p>
                <br>
                    
                <div class="div">
                    <div class="grid-container2">
                        <mat-form-field  appearance="fill" floatLabel="always">
                            <mat-label>BUSCAR</mat-label>
                            <input matInput (keyup)="filtroDataA($event)"  placeholder="INGRESE DATO A BUSCAR">
                        </mat-form-field>
                    </div>
                    <table mat-table [dataSource] = "dataSourceA" class="mat-elevation-z8">
        
                        <ng-container matColumnDef="OPCIONES">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab color="accent" matTooltip="Click aquí para ver a detalle la solicitud." (click)="clickVerDetalle(element.id_solicitud_asig_equipo,element.status_solicitud)"> <mat-icon >visibility</mat-icon> </button>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="STATUS">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> STATUS </th>
                            <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
                        </ng-container>

                        <ng-container matColumnDef="EQUIPO SOLICITADO">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> EQUIPO SOLICITADO </th>
                            <td mat-cell *matCellDef="let element"> {{element.tipo_equipo}} </td>
                        </ng-container>

                        <ng-container matColumnDef="COLABORADOR">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="CARGO DEL COLABORADOR">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="OFICINA/SUCURSAL">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> OFICINA/SUCURSAL </th>
                            <td mat-cell *matCellDef="let element"> {{element.colaborador.sucursal.nombreSucursal}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="SOLICITANTE">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                        </ng-container>

                        <ng-container matColumnDef="FECHA DE ATENCIÓN">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE ATENCIÓN</th>
                            <td mat-cell *matCellDef="let element"> {{element.fecha_mod}} </td>
                        </ng-container>
            
                        <tr mat-header-row *matHeaderRowDef="encabezadostablaA"></tr>
                        <tr mat-row *matRowDef="let row; columns: encabezadostablaA;"></tr>
                    
                    </table>
                    <mat-paginator #paginatorA class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
                </div>
                
            </div>
        </mat-tab>

        <mat-tab label="CANCELADAS">   
            <div class="inicio">
                
                <br>
                    <p class="titulo">
                        SOLICITUDES DE EQUIPO
                        <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)" >
                            <mat-icon>info</mat-icon> 
                        </button>
                    </p>
                <br>
                
                <div class="div">
                <div class="grid-container2">
                    <div class="celda">
                        <mat-form-field  appearance="fill" floatLabel="always">
                            <mat-label>BUSCAR</mat-label>
                            <input matInput (keyup)="filtroDataC($event)"  placeholder="INGRESE DATO A BUSCAR">
                        </mat-form-field>
                    </div>
                    
                </div>
                <table mat-table [dataSource] = "dataSourceC" class="mat-elevation-z8">

                    <ng-container matColumnDef="OPCIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-mini-fab color="accent" matTooltip="Click aquí para ver a detalle la solicitud." (click)="clickVerDetalle(element.id_solicitud_asig_equipo,element.status_solicitud)"> <mat-icon >visibility</mat-icon> </button>
                        </td>
                    </ng-container>
        
                    <ng-container matColumnDef="EQUIPO SOLICITADO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> EQUIPO SOLICITADO </th>
                        <td mat-cell *matCellDef="let element"> {{element.tipo_equipo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="COLABORADOR">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="CARGO DEL COLABORADOR">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="OFICINA/SUCURSAL">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OFICINA/SUCURSAL </th>
                        <td mat-cell *matCellDef="let element"> {{element.colaborador.sucursal.nombreSucursal}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="SOLICITANTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA DE CANCELACIÓN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE CANCELACIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_mod}} </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="encabezadostablaC"></tr>
                    <tr mat-row *matRowDef="let row; columns: encabezadostablaC;"></tr>
                
                </table>
                <mat-paginator #paginatorC class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div></div>
        </mat-tab>
            
        
    </mat-tab-group>

</div>